package io.horion.cv.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.ResponsiveButtonStyle
import io.horion.cv.styles.HeroContainerStyle
import io.horion.cv.styles.HeroContentBoxStyle
import io.horion.cv.styles.HeroContentColumnStyle
import io.horion.cv.styles.HeroSubtitleStyle
import io.horion.cv.styles.HeroTitleStyle
import io.horion.cv.styles.MyStyle
import io.horion.cv.styles.SpanTextStyle
import io.horion.cv.utils.Constants.POPPINS

@OptIn(DelicateApi::class)
@Composable
fun HeroSection() {
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val overlayColor = if (isDark) "rgba(0, 0, 0, 0.35)" else "rgba(0, 0, 0, 0.0)"

    Box(
        modifier = HeroContainerStyle.toModifier()
            .styleModifier {
                property("background-image", "url('1-banniere-web.webp')")
                property("background-repeat", "no-repeat")
            }
            .position(Position.Relative)
    ) {
        // Overlay sombre
        Box(
            modifier = Modifier
                .fillMaxSize()
                .styleModifier {
                    property("background", overlayColor)
                    property("transition", "background 300ms ease")
                    property("position", "absolute")
                    property("top", "0")
                    property("left", "0")
                    property("pointer-events", "none")
                }
        )

        // Contenu aligné au centre verticalement
        Box(
            modifier = HeroContentBoxStyle.toModifier()
                .fillMaxSize()
                .zIndex(10),
            contentAlignment = Alignment.CenterStart
        ) {
            Column(
                modifier = HeroContentColumnStyle.toModifier(),
                horizontalAlignment = Alignment.Start
            ) {
                SpanText(
                    text = "Cv intelligent",
                    modifier = HeroTitleStyle.toModifier()
                        .fontFamily(POPPINS)
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.DarkBlue)
                )
                SpanText(
                    text = "Créez un cv qui correspond\nau poste que vous recherchez\nen quelques minutes et sans stress",
                    modifier = HeroSubtitleStyle.toModifier()
                        .fontFamily(POPPINS)
                        .color(Colors.DarkBlue)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .textAlign(TextAlign.Start)
                )
                CustomButton(
                    text = "Créer un CV",
                    onClick = { ctx.router.navigateTo(Screen.CV.path) }
                )
            }
        }
    }
}

@Composable
fun CustomButton(
    text: String,
    onClick: (SyntheticMouseEvent) -> Unit,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val buttonTextColor = if (isDark) Colors.yellow else Colors.White

    Button(
        onClick = onClick,
        modifier = MyStyle.toModifier()
            .then(ResponsiveButtonStyle.toModifier())
            .fontFamily(POPPINS)
            .borderRadius(50.px)
            .fontWeight(FontWeight.SemiBold)
            .color(buttonTextColor)
            .styleModifier {
                property("display", "inline-flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("transition", "color 300ms ease, border-color 300ms ease")
            }
    ) {
        SpanText(
            text = text,
            modifier = SpanTextStyle.toModifier()
        )
    }
}
